import { API } from "@/api";
import { hasAnalyticsConsent } from "@/consent";

export function trackEvent(type, data = {}) {
  try {
    if (!hasAnalyticsConsent()) return;
    fetch(`${API}/stats/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        type,
        path: window.location.pathname,
        lang: data.lang || "",
        referrer: data.referrer ?? document.referrer ?? "",
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (_) {
    /* analytics must never break the app */
  }
}
